define([
    'commercial/modules/dfp/wait-for-advert'
], function (waitForAdvert) {
    return trackAdRender;
    function trackAdRender(id) {
        return waitForAdvert(id).then(function (_) { return _.whenRendered; });
    }
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/dfp/track-ad-render.js
// module id = 239
// module chunks = 0 15